import React from 'react';
import './GalleryTeste.css';

const items = [
    { content: 'Item 1', width: '200px', height: '150px', colSpan: 2, rowSpan: 1 },
    { content: 'Item 2', width: '100px', height: '100px', colSpan: 1, rowSpan: 1 },
    { content: 'Item 3', width: '150px', height: '200px', colSpan: 1, rowSpan: 2 },
    { content: 'Item 4', width: '100px', height: '100px', colSpan: 1, rowSpan: 1 },
    { content: 'Item 5', width: '200px', height: '100px', colSpan: 2, rowSpan: 1 },
    // Add more items as needed
  ];

const Gallery = () => {

    const columnGap = "20px";
    const rowGap = "20px";
  return (
    <div
      className="galleryTeste"
      style={{
        gridGap: `${rowGap} ${columnGap}`,
      }}
    >
      {items.map((item, index) => (
        <div
          key={index}
          className="galleryTeste-item"
          style={{
            gridColumn: `span ${item.colSpan || 1}`,
            gridRow: `span ${item.rowSpan || 1}`,
            width: item.width || 'auto',
            height: item.height || 'auto',
          }}
        >
          {item.content}
        </div>
      ))}
    </div>
  );
};

export default Gallery;